import { from as observableFrom, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { Command } from '../../../core/model/command';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { ComponentMessageDispatcher } from '../../../core/service/component-message-dispather.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { leaseAgreementCommand } from '../../command/lease-agreement.command';
import { MessageService } from '../../../core/service/message.service';
import { LeaseAgreementStatus } from '../../model/const/enums';

@Injectable()
export class CreateInvoiceCommandHandler implements ICommandHandler {
  constructor(
    private _dispatcher: ComponentMessageDispatcher,
    private _navigation: NavigationService,
    private _messageService: MessageService
  ) {}

  canExecute(command: Command): boolean {
    if (command.id === leaseAgreementCommand.createInvoice && command.context) {
      if (
        command.context.status &&
        command.context.status !== LeaseAgreementStatus.Draft &&
        command.context.status !== LeaseAgreementStatus.Voided
      ) {
        return true;
      } else {
        this._messageService.showMessage('LEASE_AGREEMENT.INFORMATION_TEXT.CREATE_SINGLE_INVOICE');
        return false;
      }
    }
    return false;
  }

  execute(command: Command): Observable<boolean> {
    return observableFrom(
      this._navigation.navigate(['rent-invoicing', 'add-single']).then(value => {
        if (value) {
          this._dispatcher.send(command.context.id);
          return true;
        }
        return false;
      })
    );
  }
}
